import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

import { Separator as DSSeparator } from "ds/Dropdown";
import * as Radio from "ds/Radio";

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const SimpleBodyText = styled(Typography.BodyText)`
  display: inline;
`;

export const Separator = styled(DSSeparator)`
  margin: 16px 0px;
`;

export const CliDialogWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
`;

export const InnerButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
`;

export const InnerButtonWrapperSizing = styled(InnerButtonWrapper)`
  margin-top: 52px;
`;
export const DialogWrapperSizing = styled.div`
  display: flex;
  gap: 8px;
`;

export const RadioGroup = styled(Radio.Group)`
  margin-top: 8px;
`;

export const RadioInput = styled(Radio.Input)`
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ResourceBodyText = styled(Typography.BodyText)`
  margin-bottom: 8px;
`;

export const Loading = styled(LoadingDs)`
  display: block;
  margin: 0 auto;
`;

export const LoadingSuccess = styled(Loading)`
  margin: 50px 0 0 auto;
`;
